import axios from "axios";
import { notifySessionExpired } from "../lib/authEvents";
import { getToken } from "../context/authStorage";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://spookfish.tech";

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Auto-attach the auth token so callers no longer set the header per-request.
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On an expired/invalid session, clear storage and bounce to login from anywhere in the app.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const isLoginRequest = error.config?.url?.includes("/admin/login");

    if ((status === 401 || status === 403) && !isLoginRequest) {
      notifySessionExpired();
    }

    return Promise.reject(error);
  }
);
